import * as actions from '../live-nurses.actions';
import { Action, createReducer, on } from '@ngrx/store';
import { LoadingTypes } from 'src/app/shared/models/enums/loading.enum';
import { PostedJobDto } from 'src/app/recruiting/candidates/live-nurses-new/components/job-profile/models/dto/posted-job';

export interface PostedJobState {
    postedJob: PostedJobDto;
    loading: LoadingTypes;
}

const initialState: PostedJobState = {
    postedJob: null,
    loading: LoadingTypes.INIT
};

export function liveNursesPostedJobReducer(state: PostedJobState, action: Action) {
    return createReducer(
        initialState,
        on(actions.loadLiveNursesPostedJob, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADING
        })),

        on(actions.loadLiveNursesPostedJobSuccess, (state, action) => ({
            ...state,
            postedJob: action.postedJob,
            loading: LoadingTypes.LOADED
        })),

        on(actions.loadLiveNursesPostedJobFail, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADED
        }))
    )(state, action);
}

export function reducer(state: PostedJobState | undefined, action: Action) {
    return liveNursesPostedJobReducer(state, action);
}
